import { AllMetrics } from '@app/core/models/metrics.constants';
import { StateToken } from '@ngxs/store';

export const CHART_METRICS_STATE_TOKEN = new StateToken<ChartMetricsStateModel>('chartMetrics');

export interface ChartMetricsStateModel {
  metrics: AllMetrics[];
}
